import { render, staticRenderFns } from "./CarouselItem.vue?vue&type=template&id=b9e61b98&scoped=true&lang=true&"
import script from "./CarouselItem.vue?vue&type=script&lang=js&"
export * from "./CarouselItem.vue?vue&type=script&lang=js&"
import style0 from "./CarouselItem.vue?vue&type=style&index=0&id=b9e61b98&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9e61b98",
  null
  
)

export default component.exports